// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:58:29

export default {
  "id": "color-race-obby",
  "slug": "color-race-obby",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/7503d2eb0f044c0ba76a6360230c32bb-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/7503d2eb0f044c0ba76a6360230c32bb/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Color Race Obby",
      "description": "Color Race Obby is an exciting game inspired by Roblox and Obby. Compete with players online on a field of colored blocks. Enter the race and become the champion! Join the fun!",
      "instructions": "Your goal is to run to the finish line. Watch carefully what color will be next and have time to run to the block of this color.\n\nControls on the computer:\nW,A,S,D - move the character\nSpace - jump\nMouse movement - camera movement\nTab - show cursor\n\nControls on the phone:\nLeft joystick - move the character\nRight button - jump\nSwipe on the screen - camera movement",
      "genres": [
        ".IO",
        "Agility"
      ],
      "tags": [
        "multiplayer",
        "parkour",
        "roblox",
        "speedrun"
      ]
    },
    "zh-CN": {
      "title": "彩色竞速挑战",
      "description": "色彩赛跑Obby是一款受Roblox和Obby启发的激动人心的游戏。在线与玩家在彩色方块场上竞争。加入比赛，成为冠军！一起享受乐趣！",
      "instructions": "您的目标是跑到终点线。仔细观察下一个颜色是什么，并在时间内跑到这个颜色的方块上。\n\n电脑上的控制方式：\nW,A,S,D - 移动角色\n空格 - 跳跃\n鼠标移动 - 相机移动\nTab - 显示光标\n\n手机上的控制方式：\n左侧摇杆 - 移动角色\n右侧按钮 - 跳跃\n屏幕滑动 - 相机移动",
      "genres": [
        ".IO",
        "敏捷"
      ],
      "tags": [
        "多人游戏",
        "跑酷",
        "Roblox",
        "速跑"
      ]
    },
    "zh-TW": {
      "title": "顏色賽跑Obby",
      "description": "顏色賽跑Obby是一款受Roblox和Obby啟發的刺激遊戲。在線上與玩家競賽，在彩色積木的場地上比賽。加入賽跑，成為冠軍！加入樂趣！",
      "instructions": "您的目標是跑到終點線。仔細觀察下一個會出現的顏色，並有時間跑到這個顏色的塊上。\n\n電腦上的控制方式：\nW,A,S,D - 移動角色\n空格鍵 - 跳躍\n滑鼠移動 - 相機移動\nTab - 顯示光標\n\n手機上的控制方式：\n左搖桿 - 移動角色\n右按鈕 - 跳躍\n在螢幕上滑動 - 相機移動",
      "genres": [
        ".IO",
        "靈巧度"
      ],
      "tags": [
        "多人遊戲",
        "疾走",
        "Roblox",
        "速跑"
      ]
    },
    "zh-HK": {
      "title": "彩色賽跑奧比",
      "description": "Color Race Obby 是一款受 Roblox 及 Obby 启發的刺激遊戲。在線上與玩家競賽，於彩色積木場地上奮戰。加入比賽，成為冠軍！加入樂趣！",
      "instructions": "您的目標是跑到終點線。仔細觀察下一個會出現的顏色，並在時間內跑到該顏色的方塊。\n\n電腦上的操控：\nW,A,S,D - 遊戲角色移動\n空格鍵 - 跳躍\n滑鼠移動 - 相機移動\nTab鍵 - 顯示滑鼠光標\n\n手機上的操控：\n左搖桿 - 遊戲角色移動\n右按鈕 - 跳躍\n屏幕滑動 - 相機移動",
      "genres": [
        ".IO",
        "靈敏度"
      ],
      "tags": [
        "多人遊戲",
        "跳躍冒險",
        "Roblox",
        "速度挑戰"
      ]
    },
    "ja": {
      "title": "カラーレースオッビー",
      "description": "Color Race Obbyは、RobloxとObbyにインスパイアされた刺激的なゲームです。オンラインで色のブロックのフィールドで他のプレイヤーと競い合いましょう。レースに入り、チャンピオンになる吧！楽しい時間を過ごしましょう！",
      "instructions": "ゴールまで走るのがあなたの目標です。次にどの色が出るか注意深く観察し、その色のブロックに走る時間を確保してください。\n\nコンピュータでの操作：\nW,A,S,D - キャラクターの移動\nSpace - 跳びる\nマウスの動き - カメラの移動\nTab - カーソルを表示\n\nスマートフォンでの操作：\n左ジョイスティック - キャラクターの移動\n右ボタン - 跳びる\nスクリーン上でのスワイプ - カメラの移動",
      "genres": [
        ".IO",
        "アギリティ"
      ],
      "tags": [
        "マルチプレイヤー",
        "パークアウト",
        "ロブロックス",
        "スピードラン"
      ]
    },
    "ko": {
      "title": "컬러 레이스 오비",
      "description": "콜러 레이스 오비는 Roblox와 오비를 영감으로 받은 흥미로운 게임입니다. 색상 블록의 필드에서 온라인 플레이어들과 경쟁하세요. 경주에 참가하고 챔피언이 되세요! 즐거움에 참여하세요!",
      "instructions": "목표는 종료선까지 달리는 것입니다. 다음에 나타날 색상을 주의 깊게 관찰하고 해당 색상의 블록으로 달리는 시간을 가지세요.\n\n컴퓨터 조작법:\nW,A,S,D - 캐릭터 이동\nSpace - 점프\n마우스 움직임 - 카메라 이동\nTab - 커서 표시\n\n폰 조작법:\n왼쪽 조이스틱 - 캐릭터 이동\n오른쪽 버튼 - 점프\n화면 터치 - 카메라 이동",
      "genres": [
        ".이오",
        "유연성"
      ],
      "tags": [
        "멀티플레이어",
        "파크로",
        "로빅스",
        "스피드런"
      ]
    },
    "fr": {
      "title": "Course de couleur Obby",
      "description": "Couleur Course Obby est un jeu exhilarant inspiré de Roblox et Obby. Competez en ligne avec les joueurs sur un champ de blocs colorés. Entrez dans la course et devenez le champion ! Rejoignez le plaisir !",
      "instructions": "Votre objectif est de courir jusqu'à la ligne d'arrivée. Regardez attentivement quelle couleur viendra en suivant et prenez le temps de courir jusqu'au bloc de cette couleur.\n\nCommandes sur ordinateur :\nW,A,S,D - déplacer le personnage\nEspace - sauter\nDéplacement de la souris - déplacement de la caméra\nTab - afficher le curseur\n\nCommandes sur téléphone :\nJoystick gauche - déplacer le personnage\nBouton droit - sauter\nGlisser sur l'écran - déplacement de la caméra",
      "genres": [
        ".IO",
        "Agilité"
      ],
      "tags": [
        "multijoueur",
        "évasion urbaine",
        "roblox",
        "course rapide"
      ]
    }
  }
};
